import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { apiUrl } from '../../config/api-url';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ShowroomService {

  private url: string = `${apiUrl}/showroom/settings/general`;

  constructor(private http: HttpClient) { }

  getShowroomInfo() {
    return this.http.get(this.url);
  }

  getAccountTypeData(): Observable<{ type: string; vendor?: string; }> {
    return this.http.get<{ type: string; vendor?: string; }>(`${apiUrl}/showroom/account-type`);
  }

  updateShowroomInfo(data) {
    // return this.http.put(this.url, this.getFormData(data));
    return this.http.post(this.url + '?_method=PUT', this.getFormData(data));
  }

  private getFormData(data) {
    const formData = new FormData();
    for (const key in data) {
      if (key != 'image') {
        formData.append(key, data[key])
      }
    }
    if (data.image) {
      formData.append('image', data.image, data.image.name)
    };
    return formData;
  }

}
